import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import moment from 'moment'
import { CircularProgress } from '@material-ui/core'
import { getDifferenceData } from '../utils'

import BotMessage from './BotMessage'
import UserMessage from './UserMessage'

import OperatorEditBox from './OperatorEditBox'

import {
    reclassifyMessage,
    getHistoricalDialogue,
    getStopBotEvents,
    resetHistoricalDialogue,
} from '../actions'

import './index.scss'

const CHANNELS = [
    {
        Id: '*',
        Name: 'All',
    },
    {
        Id: 'email',
        Name: 'Email',
    },
    {
        Id: 'sms',
        Name: 'SMS',
    },
]

class Dialogue extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            historicalDialogue: [],
            stopBotEvents: [],
            selectedChannel: CHANNELS[0],
        }

        this.dialogueContainerRef = React.createRef()
        this.dialogueWrapperRef = React.createRef()
    }

    componentDidMount() {
        this.toggleHumanTakeover = this.toggleHumanTakeover.bind(this)
        this.toggleExpanded = this.toggleExpanded.bind(this)
        this.onMessageSent = this.onMessageSent.bind(this)
    }

    componentDidUpdate(oldProps) {
        const element = this.dialogueContainerRef.current
        const element1 = this.dialogueWrapperRef.current

        const {
            historicalDialogueLoading,
            historicalDialogue,
            dialogueGeneralInfo,
            stopBotEvents,
        } = this.props

        if (oldProps.historicalDialogue === historicalDialogue) {
            return
        }

        if (!historicalDialogueLoading && historicalDialogue) {
            let dialogueWithoutEditableMessage = historicalDialogue.filter(
                item => item.MessageStatus !== 'PROCESSING_NOW'
            )

            let currentMessageToEdit = historicalDialogue.find(
                item => item.MessageStatus === 'PROCESSING_NOW'
            )
            if (currentMessageToEdit) {
                this.trackElapsedTime(currentMessageToEdit)

                currentMessageToEdit = { ...currentMessageToEdit }
            }

            if (dialogueGeneralInfo && dialogueGeneralInfo.length) {
                // for (const [i, item] of dialogueGeneralInfo.Items.entries()) {
                //  dialogueGeneralInfo.Items[i]['Timestamp'] = Math.floor(
                //      dialogueGeneralInfo.Items[i]['timestamp'] * 1000
                //  )
                // }
                const filteredGeneralInfo = dialogueGeneralInfo.filter(
                    item => !('Initiator' in item) && 'Description' in item
                )

                dialogueWithoutEditableMessage = [
                    ...dialogueWithoutEditableMessage,
                    ...filteredGeneralInfo,
                ].sort((a, b) => (a.Timestamp > b.Timestamp ? 1 : -1))
            }

            // console.log('DIALOGUE => ', dialogueWithoutEditableMessage)

            if (stopBotEvents) {
                const events = stopBotEvents.map(e => {
                    e.Timestamp = e.ts
                    e.stopBotEvent = true
                    return e
                })
                dialogueWithoutEditableMessage = [
                    ...dialogueWithoutEditableMessage,
                    ...events,
                ].sort((a, b) => (a.Timestamp > b.Timestamp ? 1 : -1))
            }
            this.setState(
                {
                    dialogueWithoutEditableMessage,
                    currentMessageToEdit,
                    selectedChannel: CHANNELS[0],
                },
                () => {
                    element.scrollTo(
                        0,
                        this.dialogueContainerRef.current.scrollHeight
                    )
                    element1.scrollTo(
                        0,
                        this.dialogueWrapperRef.current.scrollHeight
                    )
                }
            )
        }
    }

    componentWillUnmount() {
        this.clearElapsedTimeInterval()
    }

    clearElapsedTimeInterval() {
        const { elapsedTimeIntervalId } = this.state

        if (elapsedTimeIntervalId) {
            clearInterval(elapsedTimeIntervalId)

            this.setState({ elapsedTime: '-' })
        }
    }

    trackElapsedTime({ Timestamp }) {
        this.clearElapsedTimeInterval()

        const elapsedTimeIntervalId = setInterval(() => {
            const { elapsedTime } = getDifferenceData(Timestamp)

            this.setState({ elapsedTime })
        }, 1000)

        this.setState({ elapsedTimeIntervalId })
    }

    // eslint-disable-next-line class-methods-use-this
    formatDate(intents) {
        console.log('START FORMATTING!!!')
        Object.keys(intents).map(
            intent => intents[intent].map((entity, i) => {
                if (entity.entity === 'dateTime') {
                    console.log('Found datetime', intents[intent][i].value)
                    // intents[intent][i]['value'] = moment(intents[intent][i]['value']).format().replace('+', '-')
                    // intents[intent][i]['actual'] = moment(intents[intent][i]['actual']).format().replace('+', '-')
                    const correctedFormat = intents[intent][i].value + ':00.000-08:00'
                    // eslint-disable-next-line no-param-reassign
                    intents[intent][i].value = correctedFormat
                    // eslint-disable-next-line no-param-reassign
                    intents[intent][i].actual = correctedFormat
                    console.log('Setting to', intents[intent][i].value)
                }
                return entity
            })
        )
        console.log('finished formatting', intents)
        return intents
    }

    reclassify(newIntents, humanMessage) {
        console.log('Sending new intents', newIntents)
        const { currentMessageToEdit } = this.state
        console.log('Entering format')
        const intentsToSend = this.formatDate(newIntents)
        console.log('Formatted intents', intentsToSend)

        this.props.reclassifyMessage(
            currentMessageToEdit,
            intentsToSend,
            humanMessage
        )
        // setTimeout(() => {
        //     this.setState({ currentMessageToEdit: null })
        // }, 100)
    }

    toggleHumanTakeover() {
        const { currentMessageToEdit } = this.state

        if (!currentMessageToEdit) {
            return
        }

        currentMessageToEdit.RequiresHumanTakeover = !currentMessageToEdit.RequiresHumanTakeover

        return currentMessageToEdit
    }

    renderActiveDialogue() {
        const {
            dialogueWithoutEditableMessage,
            currentMessageToEdit,
            selectedChannel,
        } = this.state

        if (!dialogueWithoutEditableMessage) {
            return
        }
        // If is last element of convo
        const detailsArrowIsShown = index => {
            let lastHumanMessageIndex = -1
            dialogueWithoutEditableMessage.forEach((item, idx) => {
                if (item.Initiator === 'human') lastHumanMessageIndex = idx
            })
            return Boolean(
                index === lastHumanMessageIndex
                    && currentMessageToEdit
                    && !currentMessageToEdit.StopAiCommunication
            )
        }

        let channelFilteredDialog = dialogueWithoutEditableMessage

        if (selectedChannel && selectedChannel.Id !== '*') {
            channelFilteredDialog = channelFilteredDialog.filter(
                item => ('Channel' in item ? item.Channel === selectedChannel.Id : true)
            )
        }

        const getSentDate = date => moment.unix(date / 1000).format('DD MMM, HH:mm')

        return channelFilteredDialog.map((messageObj, index) => (
            <div key={index}>
                {messageObj.Initiator === 'human' && (
                    <UserMessage
                        onDetailsBoxChange={detailsEditorOpened => {
                            this.setState({ detailsEditorOpened })
                        }}
                        message={messageObj.Message}
                        sent={messageObj.Timestamp}
                        status={messageObj.LeadStatus}
                        isConversation={false}
                        channel={messageObj.Channel}
                        submitIntents={newIntents => this.reclassify(newIntents, messageObj)}
                        classifierResponse={
                            messageObj.RawClassifierResponse
                        }
                        oldClassifierResponse={
                            messageObj.RawClassifierOldResponse
                        }
                        detailsViewable={detailsArrowIsShown(index)}
                        name={messageObj.Name}
                        surname={messageObj.Surname}
                        blacklisted={messageObj.Blacklisted}
                    />
                )}
                {messageObj.Initiator === 'bot'
                && messageObj.CrmAction !== false && (
                    <BotMessage
                        message={messageObj.Message}
                        sent={messageObj.Timestamp}
                        edited={messageObj.Edited}
                        editedBy={messageObj.EditedBy}
                        followUp={messageObj.FollowUp}
                        apptSet={messageObj.AppointmentData}
                        ignoreUpdate={messageObj.IgnoreUpdateFlow}
                        HTOIgnore={messageObj.HTO}
                        status={messageObj.LeadStatus}
                        user='B'
                        oldMessage={messageObj.OldMessage}
                        isConversation={false}
                        channel={messageObj.Channel}
                        botName={messageObj.BotName}
                    />
                )}
                {messageObj.Initiator === 'bot'
                && messageObj.RequiresHumanTakeover && (
                // messageObj.RequiresHumanTakeover &&
                // messageObj.SendMessage !== false && (
                    <div className='notification-container'>
                        <div className='notification-container--text'>
                            <div className='screenAlert-icon screenAlert-info scaleInfo'>
                                <span className='screenAlert-body pulseInfoIns'></span>
                                <span className='screenAlert-dot pulseInfoIns'></span>
                            </div>
                            <p className='notification__message'>
                                HTO was set
                            </p>
                        </div>
                    </div>
                )}
                {messageObj.Description ? (
                    <div className='Dialogue__Events'>
                        {messageObj.Description
                            + (messageObj.Timestamp
                                ? ` on ${moment
                                    .unix(messageObj.Timestamp / 1000)
                                    .format('DD MMM, HH:mm')}`
                                : '')}
                    </div>
                ) : null}
                {messageObj.stopBotEvent === true && (
                    <div className='StopBot__Event'>
                        <p>
                            {messageObj.Action === 'stop'
                                ? 'Dealer Representative has stopped AI responses for this customer.'
                                : 'Dealer Representative has re-started AI responses for this customer.'}
                        </p>
                        <span>{getSentDate(messageObj.Timestamp)}</span>
                    </div>
                )}
            </div>
        ))
    }

    toggleExpanded(value) {
        this.setState({ isExpanded: value })
    }

    onMessageSent() {
        this.clearElapsedTimeInterval()

        setTimeout(() => {
            const element = this.dialogueWrapperRef.current
            element.scrollTo(0, this.dialogueWrapperRef.current.scrollHeight)
        })
    }

    hasEditableBox() {
        const { currentMessageToEdit } = this.state

        const { historicalDialogue, historicalDialogueLoading } = this.props

        let showOperatorEditBox = false

        if (
            !historicalDialogueLoading
            && historicalDialogue
            && currentMessageToEdit
        ) {
            showOperatorEditBox = true

            const stopAiCommunicationIndex = historicalDialogue.findIndex(
                element => element.StopAiCommunication
                    && element.StopAiCommunication === 1
            )

            if (stopAiCommunicationIndex !== -1) {
                showOperatorEditBox = false
            }
        }

        return showOperatorEditBox
    }

    render() {
        const {
            historicalDialogue,
            historicalDialogueLoading,
            statuses,
            statusOn,
        } = this.props

        const { currentMessageToEdit, elapsedTime } = this.state
        const activeDialogue = this.renderActiveDialogue()

        const editableBox = () => this.hasEditableBox() && (
            <OperatorEditBox
                messageToEdit={currentMessageToEdit}
                toggleHumanTakeover={this.toggleHumanTakeover}
                toggleExpanded={this.toggleExpanded}
                timers={elapsedTime}
                onMessageSent={this.onMessageSent}
            />
        )

        const dialogueListClassnames = classNames({
            OperatorDialogue__list: true,
            hasEditableBox: this.hasEditableBox(),
            // detailsEditorOpened: this.state.detailsEditorOpened,
            isExpanded: this.state.isExpanded,
        })
        let statusToRender
        if (
            statusOn
            && statusOn.show_status
            && statuses
            && statuses.length > 0
            && statuses[statuses.length - 1].Status
        ) {
            statusToRender = (
                <div className='activeStatus'>
                    <p>
                        Status:{' '}
                        {statusOn.status_map[
                            statuses[statuses.length - 1].Status
                        ] || statuses[statuses.length - 1].Status}{' '}
                    </p>
                    <p>
                        Last updated:
                        {moment
                            .unix(statuses[statuses.length - 1].ts / 1000)
                            .format('DD MMM hh:mm A')}
                    </p>
                </div>
            )
        }

        const channelSelector = () => (
            <>
                <p>Channel</p>
                <select
                    onChange={e => this.setState({
                        selectedChannel: CHANNELS.find(
                            item => item.Id === e.target.value
                        ),
                    })
                    }
                >
                    {CHANNELS.map(channel => (
                        <option key={channel.Id} value={channel.Id}>{channel.Name}</option>
                    ))}
                </select>
            </>
        )

        return (
            <div className='OperatorDialogue-wrapper'>
                {!historicalDialogueLoading && historicalDialogue && (
                    <div className='OperatorDialogue-ChannelSelector'>
                        {channelSelector()}
                    </div>
                )}
                <div className='OperatorDialogue' ref={this.dialogueWrapperRef}>
                    {historicalDialogue && statusToRender}
                    {historicalDialogueLoading && (
                        <div className='loading-wrapper'>
                            <CircularProgress size={40} />
                        </div>
                    )}

                    {!historicalDialogue && (
                        <p className='no-active-dialogue'>
                            You must select a dialog from left menu
                        </p>
                    )}
                    {!historicalDialogueLoading && historicalDialogue && (
                        <div>
                            <div
                                ref={this.dialogueContainerRef}
                                className={dialogueListClassnames}
                            >
                                {activeDialogue}
                            </div>
                            {editableBox()}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const {
        historicalDialogueLoading,
        historicalDialogue,
        statusOn,
        crmStatus,
        statuses,
        loadingStatuses,
        dialogueGeneralInfo,
        stopBotEvents,
    } = state.operatorDashboard

    if (historicalDialogue) {
        console.log('[historicalDialogue]', historicalDialogue)
    }

    return {
        historicalDialogueLoading,
        historicalDialogue,
        statusOn,
        crmStatus,
        statuses,
        loadingStatuses,
        dialogueGeneralInfo,
        stopBotEvents,
    }
}

export default connect(mapStateToProps, {
    reclassifyMessage,
    getHistoricalDialogue,
    getStopBotEvents,
    resetHistoricalDialogue,
})(React.memo(Dialogue))
